module.exports = __webpack_public_path__ + "img/justice-services.6de90eae.svg";